<template>


<div class="content">
    <div class="con-main" v-bind:class="{ change: ok ,zz: open}">
        <!--<router-link class="fb-touch" :to="{name:'index'}"><img  src="../../assets/home.png"></router-link>-->
        <!--<div class="breadcrumb">-->
            <!--<bread-crumb></bread-crumb>-->
        <!--</div>-->
        <router-view class="view" id="view"></router-view>

    </div>

</div>


</template>

<script>
    import Breadcrumb from '../layout/Breadcrumb.vue'

    export default {
        data() {
            return{
                open:false,
                ok:false
            }
        },
        components: {
            'bread-crumb':Breadcrumb,
        },
        computed: {
            isActive () {
                return this.$store.state.isActive
            },
            screenbig() {
                return this.$store.state.screenbig
            }
        },
        watch: {
            screenWidth (val) {
                if (isActive===false &&screenbig ===true) {
                    open=true;
                    ok = false;
                } else if(isActive===true &&screenbig ===false) {
                    ok = true;
                    open=false;
                }else{
                    ok =false;
                    open =false;
                }
            }
        }
    }
</script>
<style>
    /*内容view视图 布局*/
    .content{
        padding:75px 15px;
        margin-left:225px;
        transform:translateZ(0)
    }
    /*响应式布局*/
    .con-main{
        /*border: 1px solid red;*/
        position:relative;
        /*-webkit-box-shadow:-3px -3px 8px  4px rgba(17, 17, 17, 0.1);*/
        /*-moz-box-shadow:-3px -3px 8px 4px rgba(17, 17, 17, 0.1);*/
        /*box-shadow:-3px -3px 8px 4px rgba(17, 17, 17, 0.1);*/
        /*padding:20px;*/
        /*margin:0!important;*/
    }
    @media screen and (min-width: 980px){
        .con-main{
            width: 980px;
            max-width:100%;

        }
    }
    @media screen and (min-width: 1180px){
        .con-main{
            width: 100%;
        }
    }
    @media screen and (max-width: 799px){
        .content{
            margin-left:0px;
            padding-top:50px;
        }
        .con-main{
            max-width: 100%;
        }
    }


    .breadcrumb{
        position: absolute;
        /*border: 1px solid red;*/
        text-align: right;
        background-color: transparent;
        padding-top: 12px;
    }
    .view{
        /*border-top: 1px solid grey;*/
        margin-top: -2px;
        padding-top: 8px;
    }
    .change{
        width: 98%;
    }
    .zz{
        width: 78%;
    }
</style>




// WEBPACK FOOTER //
// Appmain.vue?0c06b21b